<div class="stat-tiles">
  @for (tile of tiles(); track tile.label) {
    @if (isSelectable(tile)) {
      <button
        type="button"
        class="stat-tile is-selectable"
        [class]="toneClass(tile)"
        [class.has-tone]="hasTone(tile)"
        [class.has-colour]="!!tile.colour"
        [class.is-selected]="selected() === tile.key"
        [attr.aria-pressed]="selected() === tile.key"
        (click)="choose(tile)"
      >
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: tile }"></ng-container>
      </button>
    } @else {
      <div
        class="stat-tile"
        [class]="toneClass(tile)"
        [class.has-tone]="hasTone(tile)"
        [class.has-colour]="!!tile.colour"
      >
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: tile }"></ng-container>
      </div>
    }
  }
</div>

<ng-template #content let-tile>
  <span class="stat-tile-label">{{ tile.label }}</span>
  <span class="stat-tile-value">{{ tile.value }}</span>
  @if (tile.hint) {
    <span class="stat-tile-hint">{{ tile.hint }}</span>
  }
</ng-template>
